// extracted by mini-css-extract-plugin
export default {"container":"jyKxEPQFc4itjDWDpWRB","label":"LGtB63LxNwMDju8ipupI","text":"VyIKTllDTFFxtISkJvto","termsContainer":"rw1bjKVbpbTOSEj5WKRO","pulse":"QKCuUlIJmNyssmDVkE3Q"};